<template>
  <v-container class="A4 mb-3" id="printMe">
    <span v-html="styleText"></span>
     <span class="sanjiaoxing"></span>
    <v-row class="d-flex justify-end my-header">
      <div class="d-flex print-hidden" style="padding-left: 30px;color: black;" >
        <v-select class="append-select" v-model="details.company_id" :items="companyOptions" item-text="name"
          item-value="id" menu-props="auto" hide-details label="所属拆迁公司" single-line style="max-width: 120px;color: black;"></v-select>
        <span style="margin: 0 20px"></span>

      </div>
      <v-btn @click="goBack" class="primary my-btn my-1">
        <i class="mdi mdi-arrow-left-bold"></i>返回
      </v-btn>
      <v-btn @click="confirm" class="primary my-btn  ml-1 my-1">
          <i class="mdi mdi-card-account-details"></i>保存
        </v-btn>
      <v-btn v-print="printObj" class="primary my-btn my-1 ml-1 mr-11">
        <i class="mdi mdi-printer"></i>打印
      </v-btn>
    </v-row>

    <h2 class="sequence">第 {{ seq }} 套</h2>
    <h1 class="head-1" v-if="details.garden_name=='东韵华庭'">
      嘉善县东韵华庭价格结算表
    </h1>
    <h1 class="head-1" v-else-if="details.garden_name=='金晖嘉苑'" >
      嘉善县金晖嘉苑价格结算表
    </h1>
    <h1 class="head-1" v-else>
      嘉善县魏塘街道价格结算表
    </h1>
    <v-row class="d-flex justify-space-between note-header">
      <span
        >结算单位（盖章）：
        <!-- style="border:none;border-bottom:1.5px solid #555555;width:600px;" -->
        <!-- value="嘉兴九色鹿软件科技有限公司" -->
        <input type="text" name="name" class="my-input-header" />
      </span>
      <span>
        结算编号：{{
          $moment(details.create_at)
            .utc()
            .format("YYYY")
        }}-P{{ details.project_id }}-C{{ details.id }}
      </span>
    </v-row>
    <table border="1" bordercolor="#000000">
      <tr>
        <td rowspan="3" class="head-4">安置户</td>
        <td class="head-4">户主姓名</td>
        <td colspan="3" class="input-text" style="width:160px">
          {{ details.customer }}
        </td>
        <td class="head-4 six_word">在册农业人口</td>
        <td class="input-text">{{ details.population }}</td>
        <td rowspan="3" class="head-4" style="width:50px"></td>
        <td class="head-4" style="width:50px"></td>
        <td class="input-text"></td>
        <td colspan="3" class="head-4" style="width:80px"></td>
        <td colspan="2" class="input-text" style="width:50px">
          {{ details.myarea_remain }}
        </td>
      </tr>
      <tr>
        <td class="head-4">联系电话</td>
        <td colspan="3" class="input-text">{{ details.phone }}</td>
        <!-- <td class="head-4">当前房源面积</td>
        <td class="input-text">{{ details.area.toFixed(2) }}</td> -->
        <td class="head-4">标准安置面积</td>
        <td class="input-text">
          {{ details.customer_population_area }}
        </td>
        <td class="head-4"></td>
        <td class="input-text"></td>
        <td colspan="3" class="head-4"></td>
        <td colspan="2" class="input-text"></td>
      </tr>
      <tr>
        <td class="head-4">旧房地址</td>
        <td colspan="3" class="input-text">
          {{ details.village }} {{ details.address }}
        </td>
        <td class="head-4">确认安置面积</td>
        <td class="input-text">{{ details.myarea }}</td>
        <td class="head-4"></td>
        <td></td>
        <td colspan="3" class="head-4"></td>
        <td colspan="2" class="input-text"></td>
      </tr>
      <tr>
        <td colspan="1" class="head-4">安置房源地址</td>
        <td colspan="4" class="input-text">
          {{ details.garden_name }}{{ details.building_name }}幢{{
            details.unit_name
          }}单元{{ details.house_number }}<span v-if=" details.sub_name">({{details.sub_name}})</span>
        </td>
        <td class="head-4">安置房源面积</td>
        <td class="input-text">{{ details.area }}</td>
        <td class="head-4">楼层</td>
        <td class="input-text">{{ details.floor }}</td>
        <td class="head-4">总楼层</td>
        <td colspan="2" class="input-text">{{ details.floors }}</td>
        <td colspan="2" class="head-4">层次级差</td>
        <td class="input-text">{{ details.feefloat }}</td>
      </tr>
      <tr>
        <td colspan="7" class="head-2">安置房价格结算明细</td>
        <td colspan="8" class="head-2">各项收（代）费明细</td>
      </tr>
      <tr>
        <td colspan="4" class="head-4" style="width:240px">安置标准分类</td>
        <td class="head-4">面积(㎡)</td>
        <td class="head-4">单价(元/㎡)</td>
        <td class="head-4">金额(元)</td>
        <td colspan="3" class="head-4">项目</td>
        <td class="head-4">数量</td>
        <td colspan="2" class="head-4">金额(元)</td>
        <td colspan="2" class="head-4">说明</td>
      </tr>
      <tr>
        <td colspan="4">标准价({{ details.population_price }}元/㎡)</td>
        <td class="input-text">{{ details.population_area }}</td>
        <td>{{ details.population_price_discount }}</td>
        <td class="input-text">{{ details.population_fee }}</td>
        <td colspan="3">污水处理入网费</td>
        <td></td>
        <td colspan="2" class="input-text" v-if="details.garden_name=='善和苑一期'">{{ details.wsrwf }}</td>
        <td colspan="2" class="input-text" v-else></td>
        <td colspan="2"></td>
      </tr>
      <tr>
        <td colspan="4">产权置换价({{details.property_price}}元/㎡)</td>
        <td class="input-text">{{ details.property_area }}</td>
        <td>{{ details.property_price_discount }}</td>
        <td class="input-text">{{ details.property_fee }}</td>
        <td colspan="3">房屋装修保证金</td>
        <td></td>
        <td colspan="2" class="input-text" v-if="details.garden_name=='善和苑一期'">{{ details.zxbzj }}</td>
        <td colspan="2" class="input-text" v-else></td>
        <td colspan="2"></td>
      </tr>
      <tr>
        <td colspan="4">特殊价格({{details.special_price}}元/㎡)</td>
        <td class="input-text">{{ details.special_area }}</td>
        <td>{{ details.special_price_discount }}</td>
        <td class="input-text">{{ details.special_fee }}</td>
        <td colspan="3">物业管理费</td>
        <td v-if="details.garden_name=='善和苑一期'">{{ details.area }}</td>
        <td v-else></td>
        <td colspan="2" class="input-text" v-if="details.garden_name=='善和苑一期'">{{ details.wyflf }}</td>
        <td colspan="2" class="input-text" v-else></td>
        <td colspan="2" v-if="details.garden_name=='善和苑一期'">面积 * 0.8元/㎡</td>
        <td colspan="2" v-else></td>
      </tr>
      <tr>
        <td colspan="4">套内不可分割(20㎡)({{details.extend_price}}元/㎡)</td>
        <td class="input-text">{{ details.extend_area }}</td>
        <td>{{ details.extend_price_discount }}</td>
        <td class="input-text">{{ details.extend_fee }}</td>
        <td colspan="3">垃圾清运费(套)</td>
        <td></td>
        <td colspan="2" class="input-text" v-if="details.garden_name=='善和苑一期'">{{ details.ljqyf }}</td>
        <td colspan="2" class="input-text" v-else></td>
        <td colspan="2"></td>
      </tr>
      <tr>
        <td colspan="4" >市场优惠价({{details.market_discount_price}}元/㎡)</td>
        <td class="input-text">
          {{ details.market_discount_area }}
        </td>
        <td>{{ details.market_discount_price_discount }}</td>
        <td class="input-text">
          {{ details.market_discount_fee }}
        </td>
        <td colspan="3">物业专项维修资金</td>
        <td v-if="details.garden_name=='枫雅南居' || details.garden_name=='翡翠公馆'"></td>
        <td v-else>{{ details.area }}</td>
        <td colspan="2" class="input-text" v-if="details.garden_name=='枫雅南居' || details.garden_name=='翡翠公馆'">

        </td>
        <td colspan="2" class="input-text" v-else>
          {{ details.repair_special_fee }}
        </td>
        <td colspan="2" v-if="details.garden_name=='枫雅南居' || details.garden_name=='翡翠公馆'"></td>
        <td colspan="2" v-else-if="details.garden_name=='善和苑一期'">面积 * 35元/㎡</td>
        <td colspan="2" v-else>面积 * 50元/㎡</td>
      </tr>

      <tr>
        <td colspan="4">车位、车库(1000元/㎡)</td>
        <td class="input-text">{{ details.sub_area }}</td>
        <td>{{ details.sub_price }}</td>
        <td class="input-text">{{ details.sub_fee }}</td>
        <!-- <td colspan="3" >天然气费用</td>
        <td></td>
        <td colspan="2" class="input-text">{{ details.trqfy }}</td>
        <td colspan="2"></td> -->

<!--       <td colspan="3" v-if="details.garden_name=='东韵华庭' || details.garden_name=='善新苑' || details.garden_name=='金晖嘉苑' || details.garden_name=='潇湘湖苑' || details.garden_name=='凤桐雅苑' || details.garden_name=='珑港华庭'">车库维修基金</td>-->
        <!-- 优先判断：和善家园一期/二期 等于 铁路项目 -->
        <td colspan="3"
            v-if="details.garden_name === '和善家园一期' || details.garden_name === '和善家园' ||
          details.garden_name === '和善家园二期' &&
          details.project_real_name === '铁路项目'">
          车库维修基金
        </td>

        <!-- 否则，再判断原来的小区列表 -->
        <td colspan="3"
            v-else-if="details.garden_name === '东韵华庭' ||
               details.garden_name === '善新苑' ||
               details.garden_name === '金晖嘉苑' ||
               details.garden_name === '潇湘湖苑' ||
               details.garden_name === '凤桐雅苑' ||
               details.garden_name === '珑港华庭'">
          车库维修基金
        </td>
        <td colspan="3" v-else-if="details.garden_name=='善和苑一期'">天然气费用</td>
       <td colspan="3" v-else>零星杂费</td>
<!--        <td v-if="details.garden_name=='东韵华庭' || details.garden_name=='善新苑' || details.garden_name=='金晖嘉苑' || details.garden_name=='潇湘湖苑' || details.garden_name=='凤桐雅苑'  || details.garden_name=='珑港华庭'">{{ details.sub_area }}</td>-->
        <!-- 优先：和善家园一期/二期 等于 铁路项目 -->
        <td v-if="details.garden_name === '和善家园一期' ||
          details.garden_name === '和善家园二期' ||
           details.garden_name === '和善家园' &&
          details.project_real_name === '铁路项目'">
          {{ details.sub_area }}
        </td>

        <!-- 否则：原6个小区 -->
        <td v-else-if="details.garden_name === '东韵华庭' ||
               details.garden_name === '善新苑' ||
               details.garden_name === '金晖嘉苑' ||
               details.garden_name === '潇湘湖苑' ||
               details.garden_name === '凤桐雅苑' ||
               details.garden_name === '珑港华庭'">
          {{ details.sub_area }}
        </td>
        <td v-else></td>
<!--        <td colspan="2" v-if="details.garden_name=='东韵华庭' || details.garden_name=='善新苑' || details.garden_name=='金晖嘉苑' || details.garden_name=='潇湘湖苑' || details.garden_name=='凤桐雅苑' || details.garden_name=='珑港华庭'" class="input-text">{{ details.sub_repair_fee }}</td>-->
        <!-- 优先：和善家园一期/二期 等于 铁路项目 -->
        <td colspan="2"
            v-if="details.garden_name === '和善家园一期' ||
          details.garden_name === '和善家园二期' ||
          details.garden_name === '和善家园' &&
          details.project_real_name === '铁路项目'"
            class="input-text">
          {{ details.sub_repair_fee }}
        </td>

        <!-- 否则：原6个小区 -->
        <td colspan="2"
            v-else-if="details.garden_name === '东韵华庭' ||
               details.garden_name === '善新苑' ||
               details.garden_name === '金晖嘉苑' ||
               details.garden_name === '潇湘湖苑' ||
               details.garden_name === '凤桐雅苑' ||
               details.garden_name === '珑港华庭'"
            class="input-text">
          {{ details.sub_repair_fee }}
        </td>
        <td colspan="2" class="input-text" v-else-if="details.garden_name=='善和苑一期'">{{ details.trqfy }}</td>
        <td colspan="2" v-else></td>
<!--        <td colspan="2" v-if="details.garden_name=='东韵华庭' || details.garden_name=='善新苑' || details.garden_name=='金晖嘉苑' || details.garden_name=='潇湘湖苑' || details.garden_name=='凤桐雅苑' || details.garden_name=='珑港华庭'">面积 * 35元/㎡</td>-->
        <!-- 优先：和善家园一期/二期 等于 铁路项目 -->
        <td colspan="2"
            v-if="details.garden_name === '和善家园一期' || details.garden_name === '和善家园' ||
          details.garden_name === '和善家园二期' &&
          details.project_real_name === '铁路项目'">
          面积 * 35元/㎡
        </td>

        <!-- 否则：原6个小区 -->
        <td colspan="2"
            v-else-if="details.garden_name === '东韵华庭' ||
               details.garden_name === '善新苑' ||
               details.garden_name === '金晖嘉苑' ||
               details.garden_name === '潇湘湖苑' ||
               details.garden_name === '凤桐雅苑' ||
               details.garden_name === '珑港华庭'">
          面积 * 35元/㎡
        </td>
        <td colspan="2" v-else></td>
      </tr>
      <tr v-if="details.garden_name=='善和苑一期'">
        <td colspan="4"></td>
        <td class="input-text"></td>
        <td></td>
        <td class="input-text"></td>
        <td colspan="3" >广电费用</td>
        <td></td>
        <td colspan="2" class="input-text">{{ details.gdfy }}</td>
        <td colspan="2"></td>
        <!-- <td colspan="2" v-else>面积 * 50元/㎡</td> -->
        <!-- <td colspan="3" v-if="details.garden_name=='东韵华庭' || details.garden_name=='善新苑'">车库维修基金</td>
        <td colspan="3" v-else>零星杂费</td>
        <td v-if="details.garden_name=='东韵华庭' || details.garden_name=='善新苑'">{{ details.sub_area }}</td>
        <td v-else></td>
        <td colspan="2" v-if="details.garden_name=='东韵华庭' || details.garden_name=='善新苑'" class="input-text">{{ details.sub_repair_fee }}</td>
        <td colspan="2" v-else></td>
        <td colspan="2" v-if="details.garden_name=='东韵华庭' || details.garden_name=='善新苑'">面积 * 35元/㎡</td>
        <td colspan="2" v-else></td> -->
      </tr>
      <tr>
        <td colspan="6" class="head-4">房款结算小计</td>
        <td class="input-text-red">{{ details.total_house_fee }}</td>
        <td colspan="4" class="head-4">各项(代)收费小计</td>
        <td colspan="2" class="input-text-red" v-if="details.garden_name=='枫雅南居'">

        </td>
<!--        <td colspan="2" class="input-text-red" v-else-if="details.garden_name=='东韵华庭' || details.garden_name=='善新苑' || details.garden_name=='金晖嘉苑'|| details.garden_name=='潇湘湖苑'|| details.garden_name=='凤桐雅苑' || details.garden_name=='珑港华庭'">-->
<!--          {{ (Number(details.repair_special_fee)+Number(details.sub_repair_fee)).toFixed(2) }}-->
<!--        </td>-->
        <!-- 优先：和善家园一期/二期 等于 铁路项目 -->
        <td colspan="2"
            class="input-text-red"
            v-if="details.garden_name === '和善家园一期' || details.garden_name === '和善家园' ||
          details.garden_name === '和善家园二期' &&
          details.project_real_name === '铁路项目'">
          {{ (Number(details.repair_special_fee) + Number(details.sub_repair_fee)).toFixed(2) }}
        </td>

        <!-- 否则：原6个小区 -->
        <td colspan="2"
            class="input-text-red"
            v-else-if="details.garden_name === '东韵华庭' ||
               details.garden_name === '善新苑' ||
               details.garden_name === '金晖嘉苑' ||
               details.garden_name === '潇湘湖苑' ||
               details.garden_name === '凤桐雅苑' ||
               details.garden_name === '珑港华庭'">
          {{ (Number(details.repair_special_fee) + Number(details.sub_repair_fee)).toFixed(2) }}
        </td>
        <td colspan="2" class="input-text-red" v-else-if="details.garden_name=='善和苑一期'">
          {{ (Number(details.repair_special_fee)+Number(details.wsrwf)+Number(details.gdfy)+Number(details.trqfy)+Number(details.ljqyf)+Number(details.zxbzj)+Number(details.wyflf) ).toFixed(2)}}
        </td>
        <td colspan="2" class="input-text-red" v-else>
          {{ details.repair_special_fee}}
        </td>
        <td colspan="2"></td>
      </tr>
      <tr>
        <td colspan="4" class="head-4">应收款项总计（人民币小写）</td>
        <td class="input-text-red">{{ details.total_fee }}</td>
        <td colspan="3" class="head-4">应收款项总计（人民币大写）</td>
        <td colspan="7" class="money">{{ details.total_fee_chinese }}</td>
      </tr>
    </table>

    <v-row class="d-flex justify-space-between note-footer">
      <span
        >结算经办人：
        <!-- :value="user_name" -->
        <input
          type="text"
          name="name"
          style="border:none;border-bottom:1.5px solid #555555;"
          class="my-input"
        />
      </span>
      <span
        >审核人：
        <input
          type="text"
          name="name"
          style="border:none;border-bottom:1.5px solid #555555;align:center"
          class="my-input"
        />
      </span>
      <span
        >搬迁户签名：
        <input
          type="text"
          name="name"
          style="border:none;border-bottom:1.5px solid #555555;"
          class="my-input"
        />
      </span>
      <span style="padding-right:15px">
        结算日期：
        {{
          $moment(details.delivery_time)
            .utc()
            .format("YYYY-MM-DD HH:mm:ss")
        }}
      </span>
    </v-row>
    <!-- <v-row>
        <v-col>
          <span style="padding-left:30px">注：以上内容面积单位为平方米(㎡)</span>
        </v-col>
      </v-row> -->
  </v-container>
</template>

<script>
import { fetchBill } from "@/api/bills";
import { fetchContract,updateContractById } from "@/api/contracts";
import { fetchCompanyList } from "@/api/companies";

export default {
  name: "Bill Print",
  components: {},

  filters: {},
  data() {
    return {
      styleText:'<style type="text/css">\n' + '  @page { size: landscape; }\n' + '</style>',
      seq: "",
      user_name: this.$store.getters.name,
      company: this.$store.getters.company,
      details: null,
      companyOptions: [],
      // population_price: 580,
      // property_price: 960,
      // extend20_price: 3510,
      // market_discount_price: 6110,
      // market_price: 6110,
      dt_now: "",
      printObj: {
        id: "printMe",
        popTitle: "good print",
        extraCss: "https://www.baidu.com",
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
      },
      cssBackgroundImg: {
        backgroundImage: `url(${require("@/assets/background.jpg")})`
      }
    };
  },

  computed: {
    isAdminRole() {
      if (this.$store.getters.roles.includes("admin")) {
        return true;
      } else {
        return false;
      }
    }
  },
  created() {
    this.getCompaniesList();
    this.getBill(this.$route.params.id);
    this.dt_now = Date.now();
    this.seq = this.$route.params.seq;
  },

  methods: {
    goBack() {
      console.log("goback clicked");
      this.$router.go(-1);
    },
    getBill(id) {
      this.listLoading = true;
      fetchContract(id).then(response => {
        this.details = response.data;
        // Just to simulate the time of the request
        setTimeout(() => {
          this.listLoading = false;
        }, 1.5 * 1000);
      });
    },
    getCompaniesList() {
      this.listLoading = true;
      console.log("getCompaniesList");
      fetchCompanyList().then(response => {
        this.companyOptions = response.data.items;
        setTimeout(() => {
          this.listLoading = false;
        }, 5 * 1000);
      });
    },
    confirm() {
      const detail = this.details;
      var data = {};
      data = {
          'company_id': detail.company_id,
      }

      // console.log(tempData);
      updateContractById(detail.id, data).then(response => {
        this.text = "数据保存成功";
        this.snackbar = true;
        // this.getTransition(this.$route.params.id);
      });

    },
  }
};
</script>

<style scoped>
body {
  margin: auto;
  padding: auto;
  background: rgb(65, 63, 63);
}
.A4 {
  background: rgb(180, 180, 180);
  /* width: 21cm;
  height: 29.7cm; */
  width: 1122px;
  height: 794px;
  display: block;
  /* box-shadow: 0 0 1px 1px rgb(2, 164, 252); */
  overflow-y: auto;
  box-sizing: border-box;
  margin: auto;
}
.append-select>>>.v-label {
  color: #000 !important;
  font-size: 18px;
}

.append-select>>>.v-select__selection {
  color: #000;
  font-size: 18px;
}
.head-1 {
  margin-top: 0;
  padding: 0 0 20px 0;
  font-weight: 800;
  font-size: 21pt;
  text-align: center;
}

.head-2 {
  padding: 2pt;
  font-weight: 600;
  font-size: 12pt !important;
  text-align: center;
  background-color: rgb(136, 134, 132);
}

.head-3 {
  font-weight: 400;
  font-size: 12pt !important;
  text-align: center;
}

.head-4 {
  font-weight: 400;
  font-size: 11pt !important;
  text-align: center;
  background-color: rgb(140, 160, 150);
}

.input-text {
  font-weight: 600;
  font-size: 10pt;
  color: rgb(3, 54, 192);
}

.input-text-red {
  font-weight: 700;
  font-size: 10pt;
  color: rgb(231, 5, 5);
}

.money {
  text-align: left;
  font-weight: 600;
  color: rgb(3, 54, 192);
  padding: 0 0 0 20px;
}

td {
  padding-top: 9px;
  padding-bottom: 6px;
  padding-left: 8px;
  padding-right: 8px;
}

table {
  margin: auto;
  text-align: right;
}

.flex-container {
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  justify-content: space-around;
}

.note-header {
  padding: 0px 30px 15px 40px;
}

.note-footer {
  padding: 20px 25px 10px 40px;
}

.my-input-header {
  margin: 0 500px 0 0;
  border: none;
  border-bottom: 1.5px solid #555555;
  width: 230px;
}

.my-input {
  margin: 0 35px 0 0;
}

.sanjiaoxing {
  width: 0;
  height: 0;
  border-color: transparent rgb(231, 93, 93);
  border-width: 0 0 120px 120px;
  border-style: solid;
  position: absolute;
}

.sequence {
  margin: 0 0 5px 10px;
  padding: 0 5px 0 5px;
  position: absolute;
  /* background-color: rgb(172, 104, 104); */
  transform: rotate(-45deg);
  transform-origin: 20% 40%;
}

@page {
  /* size: A4; */
  /* size: landscape; */
  margin: 0;
}

/* @media print{@page {size: landscape}} */

@media print {
  .A4 {
    background: white;
  }

  .head-2 {
    background-color: rgb(231, 229, 226);
  }

  .head-4 {
    background-color: rgb(231, 229, 226);
  }

  .my-header {
    height: 50px;
  }
  .my-btn {
    display: none;
  }

  .six_word {
    width: 120px;
  }

  .sanjiaoxing {
    display: none;
  }

  .sequence {
    display: none;
  }
  .print-hidden{
    display: none;
  }
}
</style>
